<template>
  <div id="app">
    <div class="pa">
      <div class="page">
        <ul class="vip-desc">
          <li>VIP等级</li>
          <li>VIP价格</li>
        </ul>
        <ul class="vip-s">
           <div  v-for="(item ,index) in vipdata ">
               <li class="vip-s-li-one">
                {{ item.name }}
                <img  v-show="item.st == 1" src="../clac/img/bysys.png" />
              </li>
              <li class="vip-s-li-two">
                <div class="ry"  v-show="!iosflag" >{{ item.price }}</div>
                <div class="ry" v-show="iosflag" >{{ item.aprice }}</div>

                <div class="yy">  {{ item.yprice }}</div>
                <img  v-show="item.st == 1 && item.cmtimg != ''" :src="item.cmtimg" />

              </li>
         </div>
          <!-- <li>
            永久VIP
            <img src="./img/bysy.png" />
          </li>
          <li>
            <div class="ry">1398元</div>
            <div class="yy">5200</div>
          </li>
          <li>
            一年VIP
            <img src="./img/bysy.png" />
          </li>
          <li>
            <div class="ry">999元</div>
            <div class="yy">1999</div>
          </li>
          <li>
            六个月VIP
            <img src="./img/bysy.png" />
          </li>
          <li>
            <div class="ry">518元</div>
            <div class="yy">1188</div>
          </li>
          <li>
            三个月VIP
            <img src="./img/bysy.png" />
          </li>
          <li>
            <div class="ry">288元</div>
            <div class="yy">588</div>
          </li>
          <li>一个月VIP</li>
          <li>
            <div class="ry">98元</div>
            <div class="yy">199</div>
          </li> -->
        </ul>
      </div>
      <!-- <div class="page-p">VIP功能全面，避免任何意外！</div> -->
            <div class="page-p">六个月及以上VIP买一送一：<br/> 你买VIP，你的好友也可获得同等VIP</div>


      <div @click="gunabbi()" class="foot">开会员，免等待（{{btnText}}s）</div>
    </div>

    <div class="tan-back"></div>
  </div>
</template>
<script>
import headBack from "../common/head-back";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      btnText: "15",
      pageTime: null,
       vipdata:[
       {"name":"永久VIP","price":999,"aprice":1298,"yprice":5200,st:1,cmtimg:"../../../static/img/svip1.png"},
        {"name":"一年VIP","price":798,"aprice":1098,"yprice":1999,st:1,cmtimg:""},
        {"name":"六个月VIP","price":398,"aprice":588,"yprice":1188,st:1,cmtimg:"../../../static/img/svip3.png"},
        {"name":"三个月VIP","price":218,"aprice":288,"yprice":588,st:0,cmtimg:""},
        {"name":"一个月VIP","price":98,"aprice":128,"yprice":199,st:0,cmtimg:""}
      ],
      list: [],
      iosflag:true
    };
  },

  mounted: function() {
    this.$point.init(new Date());
    this.btnText = "15";
    var showtime = 15;
    var type = this.$route.params.type;
    if (type != null) {
     this.btnText = type;
      showtime = type;
    } else {
      this.btnText = "10";
      showtime = 10;
    }

    this.getSecond(showtime);
    var ua = navigator.userAgent;
    if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;          
    }else{
      this.iosflag = false;          
    }
  },
  methods: {
    gunabbi() {
      clearTimeout(this.pageTim);
      // this.$router.push("/pay");
      window.location.href = "hqml://vipPage";
    },
    getSecond(wait) {
      console.log("等待时间");
      let _this = this;
      let _wait = wait;
      if (wait == 0) {
        window.location.href = "hqml://closeWindow";
      } else {
        this.btnText = "" + wait + "";
        wait--;
        this.pageTime = setTimeout(function() {
          _this.getSecond(wait);
        }, 1000);
      }
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1344px;
}
.pa {
  z-index: 100;
  position: fixed;
  margin: 0 auto;
  width: 100%;
}
.page {
  width: 510px;
  height: 500px;
  padding-top: 45%;
  margin: 0 auto;
  z-index: 100;
}
.page-p {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ffffff;
  text-align: center;
  margin-top: 32px;
}
.page ul {
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: center;
}
.page ul li {
  height: 80px;
  float: left;
  list-style: none;
  text-align: center;
}
.vip-desc {
  background-image: linear-gradient(90deg, #eeb08e 4%, #f9dcc1 100%);
  height: 80px;
  line-height: 80px;
  font-family: PingFangSC-Semibold;
  font-size: 26px;
  color: #2b2f3c;
  letter-spacing: -0.07px;
  text-align: center;
  font-weight: 700;
}
.vip-desc li {
  width: 50%;
}

.vip-s {
  height: 74px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #f4bf9d;
  letter-spacing: -0.06px;
  text-align: center;
  line-height: 74px;
  font-weight: 500;
}
.vip-s li {
  background: #2c3163;
  width: 253px;
  font-size: 28px;
}

.vip-s li .ry {
  width: 153px;
  height: 100%;
  float: left;
  text-align: right;
}
.vip-s li .yy {
  width: 73px;
  height: 100%;
  float: left;
  text-align: left;
   font-size: 16px;
  text-indent: 10px;
  display: block;
  text-decoration: line-through;
  line-height: 85px;
}



.vip-s-li-one img {
  position: relative;
  width: 64px;
  height: 22px;
  display: block;
  top: -74px;
  left: 190px;
}


.vip-s-li-two img {
  position: relative;
  width: 96px;
  height: 22px;
  display: block;
  top: -80px;
  left: 158px;
}

.vip-s li span {
  font-size: 8px;
  text-indent: 10px;
  display: block;
  text-decoration: line-through;
  line-height: 55px;
}

.vip-s li:nth-child(2n + 1) {
  margin: 0 0px 1px 0;
  float: left;
}
.vip-s li:nth-child(2n) {
  margin: 0 1px 1px 0px;
  float: right;
}
.foot {
  background-image: linear-gradient(180deg, #2d50ed 0%, #4ea0fe 100%);
  box-shadow: 0 2px 6px 2px #cadeff;
  border-radius: 25px;
  border-radius: 25px;
  height: 92px;
  width: 632px;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #ffffff;
  letter-spacing: -0.08px;
  text-align: center;
  margin: 110px auto 0px;
  line-height: 92px;
}
.tan-back {
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/clac/showvip.vue